// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmationModal_buttons__33r-_"};